import React, { useState, useEffect, useCallback, useRef, Fragment } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { Delete, Edit } from "../../../components/buttons/Crud";
import { validateSessionAndJwtToken } from "../../../utils/validateTokenSession";
import { AddBankAccountDialog } from "../../../components/dialogs/addBankAccount.dialog";
import { BancoPageService } from "./bancoPage.service";
import { SkeletonDahsboard } from "../../../components/skeleton/skeletonDash";
import { BasicInfoService } from "../../../services/basicinfo/basicinfo.service";
import { ErrorAlert } from "../../../components/alerts/errorAlert";
import { returnToSignin } from "../../../utils/returnToSign";
import { DashboardMyCredit } from "../../../components/backgrounds/DashboardMyCredit";
import { useCredit } from "../../../context/creditContext";
import { EditBankAccountDialog } from "../../../components/dialogs/editBankAccountDialog";
import { SuccessAlert } from "../../../components/alerts/successAlert";
import { WarningAlert } from "../../../components/alerts/warningAlert";
import {
  BadgeCheck,
  PlusIcon,
} from "lucide-react";
import { homologateBankNameAccount } from "../../../utils/options_selects";
import {
  MenuEllipsisOnClick,
  MenuEllipsisOnClickMobile,
} from "../../../components/buttons/navigation/MenuEllipsis";
import { optionsBankActions } from "../credits/utils";
import { BottomSheet } from "../../../components/new_components/BottomSheet";
import { NextButton } from "../../../components/new_components/buttonsFlow";
import { ImageCarousel } from "../../../components/new_components/carrusel";
import DialogComponent from "../../../components/new_components/dialogo";
import { reintentarUsuarioComments } from "../../../utils/commentsValidate";

import * as url from "../../../helpers/url_helper";
import { APIClient } from "../../../helpers/api_helper";

const apiClient = new APIClient();

const bancoPageService = new BancoPageService();

export function BancoPage() {
  const { disclosures, creditInfo, due } = useCredit();
  let { state } = useLocation();
  let navigate = useNavigate();
  const [disbursementStatus] = useState(localStorage.getItem("disbursementStatus"));
  const [openDialogInfo, setOpenDialogInfo] = useState(false);
  const [openDialog, setOpenDialog] = useState(false);
  const [openDialogDelete, setOpenDialogDelete] = useState(false);
  const [openDialogEdit, setOpenDialogEdit] = useState(false);
  const [openDialogConfirm, setOpenDialogConfirm] = useState(false);
  const [openDialogAlert, setOpenDialogAlert] = useState(false);
  const [bancAccount, setBancAccount] = useState({
    bankAccount: "",
    typeBankAccount: "",
    accountNumber: "",
    parent: false,
  });
  const [accountToEdit, setAccountToEdit] = useState({});
  const [accounts, setAccounts] = useState([]);
  const [features, setFeatures] = useState([]);
  const [numAccountsArrayHide, setNumAccountsArrayHide] = useState([]);
  const [numAccountsArrayCompleted, setNumAccountsArrayCompleted] = useState(
    [],
  );
  const [isMobile, setIsMobile] = useState(false);

  const [optionsMenuEllipsisCard] = useState(optionsBankActions);
  const [numAccountsArray, setNumAccountsArray] = useState([]);
  const [accountBooleanShowIcon, setAccountBooleanShowIcon] = useState([]);
  const [, setShowButtonAdd] = useState(true);
  const [isLoading, setIsLoading] = useState(true);
  const [hasOpenedBankAuto, setHasOpenedBankAuto] = useState(false);
  const [idAccount, setIdAccount] = useState("");
  const [addMainAccount, setAddMainAccount] = useState(false);
  const [name, setName] = useState("");
  const [balance, setBalance] = useState("");
  const [alert, setAlert] = useState({
    type: null, // "success" | "error" | "warning"
    message: "",
    isOpen: false,
  });

  // Ref con el valor mas reciente de `features`, usado solo para un
  // console.log de depuracion dentro del efecto de montaje (ver mas abajo).
  const featuresRef = useRef(features);
  featuresRef.current = features;

  const images = [
    { src: "/png/info-principal.png", alt: "Descripción 0" },
    { src: "/png/info-1.png", alt: "Descripción 1" },
    {
      src: "/png/info-2.png",
      alt: "Descripción 2",
    },
    { src: "/png/info-3.png", alt: "Descripción 3" },
  ];

  const handleToggle = (index) => {
    if (accountBooleanShowIcon[index]) {
      const updatedArray = [...numAccountsArrayHide];
      updatedArray.splice(index, 1, numAccountsArrayHide[index]);
      setNumAccountsArray(updatedArray);
    } else {
      const updatedArray = [...numAccountsArrayHide];
      updatedArray.splice(index, 1, numAccountsArrayCompleted[index]);
      setNumAccountsArray(updatedArray);
    }

    const ArrayShowIcon = [...accountBooleanShowIcon];
    ArrayShowIcon.splice(index, 1, !accountBooleanShowIcon[index]);
    setAccountBooleanShowIcon(ArrayShowIcon);
  };

  const handleOpenDialogAddAccount = (e) => {
    e.preventDefault();
    setBancAccount({
      accountNumber: "",
      typeBankAccount: "",
      bankAccount: "",
      parent: false,
    });
    setOpenDialog(true);
  };
  const handleOpenDialogInfoAccount = useCallback((e) => {
    setOpenDialogInfo((prev) => !prev);
  }, []);

  const handleOpenDialogEditAccount = useCallback((id) => {
    setIdAccount(id);
    let accountToEdit = accounts.filter((ac) => ac?.id === id)[0];
    setAccountToEdit(accountToEdit);
    setOpenDialogEdit(true);
  }, [accounts]);

  const handleOpenAlert = (type, message) => {
    // Primero cerramos el alert para forzar re-render
    setAlert({
      type: null,
      message: "",
      isOpen: false,
    });

    // Luego lo abrimos en el siguiente ciclo
    setTimeout(() => {
      setAlert({
        type,
        message,
        isOpen: true,
      });
    }, 10);
  };

  const refreshAccounts = async () => {
    let _accounts = await bancoPageService.loadAccounts();
    if (_accounts.length >= 4) {
      setShowButtonAdd(false);
    } else {
      setShowButtonAdd(true);
    }
    bancoPageService.mapAccounts(_accounts, {
      setNumAccountsArray,
      setNumAccountsArrayHide,
      setNumAccountsArrayCompleted,
      setFeatures,
      setAccountBooleanShowIcon,
    });
    setAccounts(_accounts);
  };

  const updateAddMainAccount = (hasAddMainAccount) => {
    setAddMainAccount(hasAddMainAccount);
  };

  const deleteAccount = async (id) => {
    try {
      let payload = {
        id,
        doc: localStorage.getItem("doc"),
      };
      await BasicInfoService.deleteBankAccount(payload.doc, payload.id);
      refreshAccounts();
    } catch (error) {
      console.error(error);
    }
  };

  const changePrincipalAccount = async (id) => {
    try {
      let accountSelected = accounts.filter((acc) => acc.id === id)[0];
      let payload = {
        bankAccount: accountSelected,
        doc: localStorage.getItem("doc"),
      };
      await BasicInfoService.changePrincipalBankAccount(payload);
      let disbursementComment = localStorage.getItem("disbursementComment");
      let credit_id = localStorage.getItem("credit_id");
      await refreshAccounts();
      if (
        reintentarUsuarioComments.includes(disbursementComment) &&
        disbursementStatus === "Fallido"
      ) {
        retryDisbursement(credit_id);
      }
    } catch (error) {
      console.error(error);
    }
  };

  const retryDisbursement = async (credit_id) => {
    try {
      if (!credit_id) return {};
      const { data } = await apiClient.create(url.RETRY_DISBURSEMENT, {
        idcredito: credit_id,
      });
      let _disbursementData = data?.data;
      if (_disbursementData?.success) return _disbursementData ?? {};
    } catch (error) {
      console.error(error);
      return {};
    }
  };

  const toggleDialogDelete = (id) => {
    setIdAccount(id);
    setOpenDialogDelete(!openDialogDelete);
    return;
  };

  const toggleDialogConfirm = (id) => {
    setIdAccount(id);
    setOpenDialogConfirm(!openDialogConfirm);
    return;
  };

  useEffect(() => {
    const docSession = localStorage.getItem("doc");
    const validSessionAndTokenJwt = async () => {
      try {
        let isValidToken = await validateSessionAndJwtToken();
        return isValidToken;
      } catch (error) {
        return false;
      }
    };
    const loadBankAccounts = async () => {
      let info = await bancoPageService.loadAccounts();
      return info;
    };

    if (state) {
      if (state?.name) {
        setName(state?.name);
      }
      if (state?.balance) {
        setBalance(state?.balance);
      }
    }

    validSessionAndTokenJwt()
      .then(async (isValidToken) => {
        if (isValidToken) {
          try {
            let _accounts = await loadBankAccounts();
            if (_accounts.length === 0) {
              let basicInfo = await bancoPageService.loadBasicInfo();
              if (Object.keys(basicInfo).length > 0) {
                let account = {
                  bankAccount: basicInfo?.bankAccount,
                  typeBankAccount: basicInfo?.typeBankAccount,
                  accountNumber: basicInfo?.accountNumber,
                  parent: true,
                };
                await bancoPageService.mapAccounts([account], {
                  setNumAccountsArray,
                  setNumAccountsArrayHide,
                  setNumAccountsArrayCompleted,
                  setFeatures,
                  setAccountBooleanShowIcon,
                });
              }
            } else {
              await bancoPageService.mapAccounts(_accounts, {
                setNumAccountsArray,
                setNumAccountsArrayHide,
                setNumAccountsArrayCompleted,
                setFeatures,
                setAccountBooleanShowIcon,
              });
            }

            if (_accounts.length === 4) {
              setShowButtonAdd(false);
            }
            setAccounts(_accounts);
            await bancoPageService.determineAddMainAccount(
              docSession,
              updateAddMainAccount,
            );

            console.log(featuresRef.current);

            setIsLoading(false);
          } catch (error) {
            console.log(error);
            localStorage.removeItem("doc");
            localStorage.setItem("is_signin", false);
            return navigate("/ingresar");
          }
        } else {
          returnToSignin(navigate);
        }
      })
      .catch((e) => {
        console.log(e);
        returnToSignin(navigate);
      });
  }, [navigate, state]);

  const openBankAuto = useCallback(() => {
    setTimeout(() => {
      if (disbursementStatus === "Fallido") {
        if (features.length > 0) {
          for (let i = 0; i < features.length; i++) {
            const feature = features[i];
            if (feature.check === true) {
              handleOpenDialogEditAccount(feature.id);
            }
          }
        }
      }
    }, 2000);
  }, [disbursementStatus, features, handleOpenDialogEditAccount]);

  useEffect(() => {
    if (features.length > 0 && !hasOpenedBankAuto) {
      openBankAuto();
      setHasOpenedBankAuto(true);
    }
  }, [features, hasOpenedBankAuto, openBankAuto]);

  useEffect(() => {
    setTimeout(() => {
      if (disbursementStatus !== "Fallido") {
        handleOpenDialogInfoAccount();
      }
    }, 1000);
    // `handleOpenDialogInfoAccount` ahora usa setOpenDialogInfo(prev => !prev)
    // y esta memoizada con useCallback([]), por lo que su referencia es
    // estable entre renders: agregarla aqui ya no dispara un loop.
  }, [disbursementStatus, handleOpenDialogInfoAccount]);

  useEffect(() => {
    const checkIfMobile = () => {
      setIsMobile(window.innerWidth <= 768);
    };

    checkIfMobile();
    window.addEventListener("resize", checkIfMobile);

    return () => window.removeEventListener("resize", checkIfMobile);
  }, []);

  if (isLoading) {
    return (
      <Fragment>
        <DashboardMyCredit
          name={"Cargando"}
          balance={""}
          current={"4"}
          title={"Conecta con tus bancos"}
          main={
            <>
              <div className="pt-4 px-6 lg:px-0">
                Elige el banco donde quieres recibir tus créditos de Galilea
              </div>
              <div className="py-6 grid grid-cols-8 gap-4 px-6 lg:px-0">
                <div className="relative col-span-8 md:col-span-4 grid content-between h-full rounded-2xl transition p-4 bg-white">
                  <div className="flex justify-between">
                    <SkeletonDahsboard height={25} width={80} />
                  </div>

                  <div className="absolute w-6 h-6 rounded-full right-4 top-4">
                    <SkeletonDahsboard
                      variant={"circular"}
                      height={20}
                      width={20}
                    />
                  </div>

                  <div className="pb-4">
                    {/* La parte de detalles */}

                    <div>
                      <div className="py-0 md:grid grid-cols-8 pt-3">
                        <span className="col-span-4 text-base font-medium md:text-base">
                          <SkeletonDahsboard height={20} width={40} />
                        </span>
                        <div className="col-span-4 flex">
                          <SkeletonDahsboard height={20} width={90} />
                        </div>
                        <span className="col-span-4 text-base font-medium md:text-base">
                          <SkeletonDahsboard height={20} width={110} />
                        </span>
                        <div className="col-span-4 flex">
                          <SkeletonDahsboard height={20} width={50} />
                        </div>
                        <span className="col-span-4 text-base font-medium md:text-base">
                          <SkeletonDahsboard height={20} width={130} />
                        </span>
                        <div className="col-span-4 flex">
                          <SkeletonDahsboard height={20} width={90} />
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="flex justify-end space-x-4">
                    <Delete />
                    <Edit />
                  </div>
                </div>
                <div className="relative col-span-8 md:col-span-4 grid content-between h-full rounded-2xl transition p-4 bg-white">
                  <div className="flex justify-between">
                    <SkeletonDahsboard height={25} width={80} />
                  </div>

                  <div className="absolute w-6 h-6 rounded-full right-4 top-4">
                    <SkeletonDahsboard
                      variant={"circular"}
                      height={20}
                      width={20}
                    />
                  </div>

                  <div className="pb-4">
                    {/* La parte de detalles */}

                    <div>
                      <div className="py-0 md:grid grid-cols-8 pt-3">
                        <span className="col-span-4 text-base font-medium md:text-base">
                          <SkeletonDahsboard height={20} width={40} />
                        </span>
                        <div className="col-span-4 flex">
                          <SkeletonDahsboard height={20} width={90} />
                        </div>
                        <span className="col-span-4 text-base font-medium md:text-base">
                          <SkeletonDahsboard height={20} width={110} />
                        </span>
                        <div className="col-span-4 flex">
                          <SkeletonDahsboard height={20} width={50} />
                        </div>
                        <span className="col-span-4 text-base font-medium md:text-base">
                          <SkeletonDahsboard height={20} width={130} />
                        </span>
                        <div className="col-span-4 flex">
                          <SkeletonDahsboard height={20} width={90} />
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="flex justify-end space-x-4">
                    <Delete />
                    <Edit />
                  </div>
                </div>
                <div className="relative col-span-8 md:col-span-4 grid content-between h-full rounded-2xl transition p-4 bg-white">
                  <div className="flex justify-between">
                    <SkeletonDahsboard height={25} width={80} />
                  </div>

                  <div className="absolute w-6 h-6 rounded-full right-4 top-4">
                    <SkeletonDahsboard
                      variant={"circular"}
                      height={20}
                      width={20}
                    />
                  </div>

                  <div className="pb-4">
                    {/* La parte de detalles */}

                    <div>
                      <div className="py-0 md:grid grid-cols-8 pt-3">
                        <span className="col-span-4 text-base font-medium md:text-base">
                          <SkeletonDahsboard height={20} width={40} />
                        </span>
                        <div className="col-span-4 flex">
                          <SkeletonDahsboard height={20} width={90} />
                        </div>
                        <span className="col-span-4 text-base font-medium md:text-base">
                          <SkeletonDahsboard height={20} width={110} />
                        </span>
                        <div className="col-span-4 flex">
                          <SkeletonDahsboard height={20} width={50} />
                        </div>
                        <span className="col-span-4 text-base font-medium md:text-base">
                          <SkeletonDahsboard height={20} width={130} />
                        </span>
                        <div className="col-span-4 flex">
                          <SkeletonDahsboard height={20} width={90} />
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="flex justify-end space-x-4">
                    <Delete />
                    <Edit />
                  </div>
                </div>
                <div className="relative col-span-8 md:col-span-4 grid content-between h-full rounded-2xl transition p-4 bg-white">
                  <div className="flex justify-between">
                    <SkeletonDahsboard height={25} width={80} />
                  </div>

                  <div className="absolute w-6 h-6 rounded-full right-4 top-4">
                    <SkeletonDahsboard
                      variant={"circular"}
                      height={20}
                      width={20}
                    />
                  </div>

                  <div className="pb-4">
                    {/* La parte de detalles */}

                    <div>
                      <div className="py-0 md:grid grid-cols-8 pt-3">
                        <span className="col-span-4 text-base font-medium md:text-base">
                          <SkeletonDahsboard height={20} width={40} />
                        </span>
                        <div className="col-span-4 flex">
                          <SkeletonDahsboard height={20} width={90} />
                        </div>
                        <span className="col-span-4 text-base font-medium md:text-base">
                          <SkeletonDahsboard height={20} width={110} />
                        </span>
                        <div className="col-span-4 flex">
                          <SkeletonDahsboard height={20} width={50} />
                        </div>
                        <span className="col-span-4 text-base font-medium md:text-base">
                          <SkeletonDahsboard height={20} width={130} />
                        </span>
                        <div className="col-span-4 flex">
                          <SkeletonDahsboard height={20} width={90} />
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="flex justify-end space-x-4">
                    <Delete />
                    <Edit />
                  </div>
                </div>
              </div>
            </>
          }
        />
      </Fragment>
    );
  }

  return (
    <Fragment>
      {alert.isOpen && alert.type === "success" && (
        <SuccessAlert
          isOpen={alert.isOpen}
          message={alert.message}
          anchorOrigin={{ vertical: "bottom", horizontal: "right" }}
        />
      )}

      {alert.isOpen && alert.type === "error" && (
        <ErrorAlert
          isOpen={alert.isOpen}
          message={alert.message}
          anchorOrigin={{ vertical: "bottom", horizontal: "right" }}
        />
      )}

      {alert.isOpen && alert.type === "warning" && (
        <WarningAlert
          isOpen={alert.isOpen}
          message={alert.message}
          anchorOrigin={{ vertical: "bottom", horizontal: "right" }}
          isDesktop={!isMobile}
        />
      )}
      <DashboardMyCredit
        name={name ?? ""}
        balance={balance ?? ""}
        current={"4"}
        title={"Conecta con tus bancos"}
        disclosures={disclosures}
        creditInfo={creditInfo}
        due={due}
        main={
          <>
            <BottomSheet
              open={openDialogInfo}
              isDesktop={!isMobile}
              onOpenChange={handleOpenDialogInfoAccount}
              footerContent={
                <div className="flex items-center justify-center gap-5 h-16">
                  <NextButton
                    finishLabel={"Entendido"}
                    isLastStep={true}
                    showIconNext={false}
                    onNext={(e) => {
                      handleOpenDialogInfoAccount(e);
                    }}
                    isUnicButtom={true}
                  />
                </div>
              }
            >
              <div
                style={{
                  height: "60%",
                  display: "flex",
                  flexDirection: "column",
                  justifyContent: "space-between",
                  marginTop: "50px",
                }}
              >
                <h1
                  className="font-bold2 text-white text-center text-lg"
                  style={{
                    margin: "20px",
                  }}
                >
                  Elige el banco donde quieres recibir tus futuros créditos de
                  Galilea.
                </h1>

                <ImageCarousel images={images} />
              </div>
            </BottomSheet>

            <AddBankAccountDialog
              dialogOpen={openDialog}
              setDialogOpen={setOpenDialog}
              _state={bancAccount}
              setState={setBancAccount}
              refreshAccounts={refreshAccounts}
              addMainAccount={addMainAccount}
              features={features}
              handleOpenAlert={handleOpenAlert}
            />

            <EditBankAccountDialog
              dialogOpen={openDialogEdit}
              setDialogOpen={setOpenDialogEdit}
              _state={bancAccount}
              setState={setBancAccount}
              refreshAccounts={refreshAccounts}
              addMainAccount={addMainAccount}
              features={features}
              accountToEdit={accountToEdit}
              handleOpenAlert={handleOpenAlert}
            />

            {openDialogDelete && (
              <DialogComponent
                open={openDialogDelete}
                onOpenChange={setOpenDialogDelete}
                title="Eliminar banco"
                description="¿Estás seguro que deseas eliminar este banco?"
                showAcceptButton={true}
                showCancelButton={true}
                acceptText="Eliminar"
                cancelText="Aún no"
                onAccept={() => {
                  deleteAccount(idAccount);
                  setOpenDialogDelete(false);
                }}
                onCancel={() => setOpenDialogDelete(false)}
                isLoadingAccept={false}
                disableAccept={false}
                isDesktop={!isMobile}
                disableBackdropClose={true}
                showCloseButton={false}
              />
            )}

            {openDialogConfirm && (
              <DialogComponent
                open={openDialogConfirm}
                onOpenChange={setOpenDialogConfirm}
                title="Cambiar a banco principal"
                description="¿Estás seguro que quieres seleccionar esta cuenta para tus futuros desembolsos?"
                showAcceptButton={true}
                showCancelButton={true}
                acceptText="Sí, estoy seguro"
                cancelText="Aún no"
                onAccept={() => {
                  changePrincipalAccount(idAccount);
                  setOpenDialogConfirm(false);
                }}
                onCancel={() => setOpenDialogConfirm(false)}
                isLoadingAccept={false}
                disableAccept={false}
                isDesktop={!isMobile}
                disableBackdropClose={true}
                showCloseButton={false}
              />
            )}

            {openDialogAlert && (
              <DialogComponent
                open={openDialogAlert}
                onOpenChange={setOpenDialogAlert}
                title="Acción no permitida"
                description="Tienes un crédito en proceso de desembolso, no puedes modificar el banco principal"
                showAcceptButton={true}
                acceptText="Entendido"
                onAccept={() => {
                  setOpenDialogAlert(false);
                }}
                isLoadingAccept={false}
                disableAccept={false}
                isDesktop={!isMobile}
                disableBackdropClose={true}
                showCloseButton={false}
              />
            )}
            <div className="pt-4 px-6 lg:px-0 flex flex-col items-end gap-5 md:flex-row md:justify-between md:items-center md:gap-0">
              <span>
                El banco que esta como principal es donde recibiras los proximos
                créditos de galilea, puedes agregar{" "}
                <span className="font-bold">hasta 4 bancos</span>, editarlos o
                eliminarlos
              </span>
              <button
                style={{ padding: "5px 5px" }}
                className="bg-purple rounded-full cursor-pointer"
                onClick={handleOpenDialogAddAccount}
              >
                <PlusIcon className="w-6 h-6 text-white" />
              </button>
            </div>
            <div className="py-6 grid grid-cols-8 gap-4 px-6 lg:px-0 mb-32 md:mb-0">
              {features.map((feature, index) => (
                <div
                  key={feature.id}
                  className={
                    "col-span-8 md:col-span-4 grid content-between h-full rounded-2xl transition p-4 bg-white"
                  }
                >
                  {/* background-color: #5c5c5c; */}
                  <div className="flex h-full flex-col gap-8 justify-between">
                    <div className="flex flex-col gap-6">
                      <div className="flex items-center justify-between">
                        <div
                          key={index}
                          className="flex justify-center items-center rounded-3xl"
                          style={{
                            backgroundColor:
                              feature.check === true ? "#7e02fc" : "#f6f3f4",
                            width: "75px",
                            height: "18px",
                          }}
                        >
                          <div
                            className="text-lg font-bold"
                            style={{
                              color:
                                feature.check === true ? "#ffffff" : "#99a1af",
                              letterSpacing: "1px",
                              fontSize: "9px",
                            }}
                          >
                            {feature.title}
                          </div>
                        </div>
                        <div className="flex justify-between gap-3">
                          {feature.check && (
                            <BadgeCheck
                              width={30}
                              height={30}
                              style={{ color: "#7e02fc" }}
                            />
                          )}

                          <div
                            className={
                              "rounded-full flex justify-center items-center"
                            }
                            style={{
                              width: "30px",
                              height: "30px",
                              padding:
                                feature?.nameBanco === "Bancolombia"
                                  ? "3px"
                                  : "0px",
                              backgroundColor:
                                feature?.nameBanco === "Bancolombia"
                                  ? "black"
                                  : "transparent",
                            }}
                          >
                            {homologateBankNameAccount(
                              feature?.nameBanco,
                              "icon",
                            )}
                          </div>

                          <div
                            key={feature.title}
                            className="flex justify-between"
                          >
                            {optionsMenuEllipsisCard && (
                              <Fragment key={"fragment-options-menu-ellipsis"}>
                                <div className="hidden md:block">
                                  <MenuEllipsisOnClick
                                    options={optionsMenuEllipsisCard}
                                    principal={feature.check}
                                    onClickAcction={(action) => {
                                      
                                      if (action === "deleteAccount") {
                                        toggleDialogDelete(feature.id);
                                      } else if (action === "mainAccount") {
                                        if (
                                          disbursementStatus === "En proceso"
                                        ) {
                                          setOpenDialogAlert(true);
                                        } else {
                                          toggleDialogConfirm(feature.id);
                                        }
                                      } else if (action === "editAccount") {
                                        if (
                                          disbursementStatus === "En proceso"
                                        ) {
                                          setOpenDialogAlert(true);
                                        } else {
                                          handleOpenDialogEditAccount(
                                            feature.id,
                                          );
                                        }
                                      }
                                    }}
                                  />
                                </div>
                                <div className="z-50 block md:hidden">
                                  <MenuEllipsisOnClickMobile
                                    options={optionsMenuEllipsisCard}
                                    principal={feature.check}
                                    onClickAcction={(action) => {
                                      
                                      if (action === "deleteAccount") {
                                        toggleDialogDelete(feature.id);
                                      } else if (action === "mainAccount") {
                                        if (
                                          disbursementStatus === "En proceso"
                                        ) {
                                          setOpenDialogAlert(true);
                                        } else {
                                          toggleDialogConfirm(feature.id);
                                        }
                                      } else if (action === "editAccount") {
                                        if (
                                          disbursementStatus === "En proceso"
                                        ) {
                                          setOpenDialogAlert(true);
                                        } else {
                                          handleOpenDialogEditAccount(
                                            feature.id,
                                          );
                                        }
                                      }
                                    }}
                                  />
                                </div>
                              </Fragment>
                            )}
                          </div>
                        </div>
                      </div>
                      <div className="flex flex-col gap-2">
                        <div>
                          {/* La parte de detalles */}

                          {feature.details.map((detail, i) => {
                            if (detail.name === "Banco") {
                              return (
                                <div key={i}>
                                  <div className="py-0 flex flex-col">
                                    <span
                                      className="col-span-4 text-base text-grayP md:text-base"
                                      style={{
                                        fontSize: "10px",
                                        fontWeight: "600",
                                        letterSpacing: "1px",
                                      }}
                                    >
                                      {detail.name}{" "}
                                    </span>
                                    <div
                                      className="col-span-4 flex"
                                      style={{
                                        fontWeight:
                                          detail.name === "Banco"
                                            ? "600"
                                            : "400",
                                        letterSpacing: "1px",
                                      }}
                                    >
                                      <div>{detail.value}</div>
                                    </div>
                                  </div>
                                </div>
                              );
                            }
                            return null;
                          })}
                        </div>

                        <div className="flex justify-between">
                          {/* La parte de detalles */}

                          {feature.details.map((detail, i) => {
                            if (detail.name !== "Banco") {
                              return (
                                <div key={i}>
                                  <div className="py-0 flex flex-col">
                                    <span
                                      className="col-span-4 text-base text-grayP md:text-base"
                                      style={{
                                        fontSize: "10px",
                                        fontWeight: "600",
                                        letterSpacing: "1px",
                                        color: "#99a1af",
                                      }}
                                    >
                                      {detail.name}{" "}
                                    </span>
                                    <div
                                      className="col-span-4 flex"
                                      style={{
                                        fontWeight: "400",
                                        letterSpacing: "1px",
                                      }}
                                    >
                                      {detail.name.includes("Número") ? (
                                        <>
                                          <div
                                            style={{
                                              fontSize: "12px",
                                            }}
                                          >
                                            {numAccountsArray[index]}
                                          </div>
                                          <div
                                            key={index}
                                            className="ml-2 pt-1 eyeicon-account"
                                            onClick={() => handleToggle(index)}
                                          >
                                            {accountBooleanShowIcon[index]
                                              ? detail.iconHide
                                              : detail.iconShow}
                                          </div>
                                        </>
                                      ) : (
                                        <div
                                          style={{
                                            textTransform: "capitalize",
                                            fontSize: "13px",
                                          }}
                                        >
                                          {detail.value}
                                        </div>
                                      )}
                                    </div>
                                  </div>
                                </div>
                              );
                            }
                            return null;
                          })}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              ))}
              {/* {showButtonAdd && (
                <a
                  href="/"
                  onClick={handleOpenDialogAddAccount}
                  className="text-xl min-h-40 border-dashed border-2 rounded-3xl col-span-8 md:col-span-4 text-center grid content-center text-tgray font-bold py-6"
                >
                  <span>Agregar cuenta bancaria +</span>
                </a>
              )} */}
            </div>
          </>
        }
      />
    </Fragment>
  );
}
